//@ts-check
import React from 'react';
import moment from 'moment';
import MissingValue from './MissingValue';
export var Variants = {
  short: 'HH:mm:ss.SSS' // total duration

};
/**
 * @param {import('./types').DurationFormatter} props
 */

var DurationFormatter = function DurationFormatter(_ref) {
  var value = _ref.value,
      format = _ref.format,
      variant = _ref.variant,
      fallback = _ref.fallback;
  if (typeof value === 'undefined' || value === null) return fallback;
  var formatString = '';

  if (format) {
    formatString = format;
  } else if (variant) {
    if (!Variants[variant]) return 'Invalid variant';
    formatString = Variants[variant];
  }

  var durationInMs = 1;

  if (value instanceof Array && value.length == 2) {
    durationInMs = moment(value[1]).diff(value[0]);
  } else if (typeof value === 'string') {
    var momentDuration = moment.duration(value);
    if (!momentDuration.isValid()) return 'Invalid value';
    durationInMs = momentDuration.asMilliseconds();
  }

  return formatDate(Math.abs(durationInMs), formatString);
};
/**
 * @param {number} durationInMs Duration specified in milliseconds
 * @param {string} formatString Formatting string
 * @returns {string} The formatted duration
 */


var formatDate = function formatDate(durationInMs, formatString) {
  var MS_SEC = 1000;
  var MS_MIN = 60 * MS_SEC;
  var MS_HOUR = 60 * MS_MIN;
  var MS_DAY = 24 * MS_HOUR;
  var separators = [':', '.', '/', '-'];
  var tokenDefs = {
    // years: /Y{4}/,
    // months: /M{2}/,
    // weeks: /W{2}/,
    days: /D{2}/,
    hours: /H{2}/,
    minutes: /m{2}/,
    seconds: /s{2}/,
    milliseconds: /S{3}/,
    separators: /[:./-]+/
  };
  var tokenizer = new RegExp(Object.keys(tokenDefs).map(function (type) {
    return tokenDefs[type].source;
  }).join('|'), 'g');
  var matches = formatString.match(tokenizer);
  if (matches == null) return 'Invalid format';
  var unitSpan = 1;
  var out = '';

  for (var i = 0; i < matches.length; i++) {
    var group = matches[i];
    if (group == 'DD') unitSpan = MS_DAY;else if (group == 'HH') unitSpan = MS_HOUR;else if (group == 'mm') unitSpan = MS_MIN;else if (group == 'ss') unitSpan = MS_SEC;else if (group === 'SSS') unitSpan = 1;else return 'Invalid format';
    var value = Math.floor(durationInMs / unitSpan);
    out += value.toString().padStart(group.length, '0');
    if (i == matches.length - 1) return out;
    var sep = matches[++i];
    if (separators.indexOf(sep) == -1) return 'Invalid format';
    out += sep;
    durationInMs = durationInMs % unitSpan; // extract the rest of the duration
  }

  return out;
};

DurationFormatter.defaultProps = {
  variant: 'short',
  fallback: React.createElement(MissingValue, null)
};
export default DurationFormatter;